var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card-content",
    { staticClass: "content", class: { header: _vm.isHeader } },
    [
      _vm._t("before"),
      _c(
        "w-row",
        [
          _c("w-col", { attrs: { xs: "12" } }, [
            _c(
              "div",
              { staticClass: "section-title" },
              [
                _vm._v(_vm._s(_vm.sectionTitle) + " "),
                _c("w-spacer"),
                _vm._v(" "),
                _c(
                  "w-link",
                  {
                    on: {
                      click: function ($event) {
                        _vm.editStyle = true
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$ct("edit-style")))]
                ),
              ],
              1
            ),
          ]),
        ],
        1
      ),
      _c(
        "w-row",
        [
          _c(
            "w-col",
            { attrs: { xs: "12", md: "6" } },
            [
              _c("w-input", {
                attrs: { fancy: "", label: _vm.$ct("fieldName") },
                model: {
                  value: _vm.value.Text.Translations[_vm.selectedLanguage],
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.value.Text.Translations,
                      _vm.selectedLanguage,
                      $$v
                    )
                  },
                  expression: "value.Text.Translations[selectedLanguage]",
                },
              }),
            ],
            1
          ),
          _c(
            "w-col",
            { attrs: { xs: "12", md: "6" } },
            [
              _c("app-prop-select-autocomplete", {
                attrs: {
                  fancy: "",
                  label: _vm.$ct("prop"),
                  items: _vm.propItems,
                  "allow-empty": "",
                },
                model: {
                  value: _vm.value.Prop,
                  callback: function ($$v) {
                    _vm.$set(_vm.value, "Prop", $$v)
                  },
                  expression: "value.Prop",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._l(_vm.value.Conditions, function (condition, i) {
        return _c(
          "w-transition-slide-height",
          { key: condition.key },
          [
            _vm.shouldShowKey(condition.key)
              ? _c("app-condition-edit", {
                  attrs: {
                    value: condition,
                    "is-first": i == 0,
                    fields: _vm.conditionProps,
                    "model-name": _vm.modelName,
                  },
                  on: {
                    remove: function ($event) {
                      return _vm.removeCondition(i)
                    },
                  },
                })
              : _vm._e(),
          ],
          1
        )
      }),
      _vm._t("before-filters"),
      _c(
        "w-row",
        [
          _vm._t("after"),
          _c("w-spacer"),
          _c(
            "w-button",
            {
              attrs: { flat: "" },
              on: {
                click: function ($event) {
                  return _vm.addCondition()
                },
              },
            },
            [
              _c("w-fa", { attrs: { icon: "plus" } }),
              _vm._v(" " + _vm._s(_vm.$ct("add-filter"))),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "w-modal",
        {
          model: {
            value: _vm.editStyle,
            callback: function ($$v) {
              _vm.editStyle = $$v
            },
            expression: "editStyle",
          },
        },
        [
          _vm.editStyle
            ? _c("app-style-editor", {
                on: {
                  close: function ($event) {
                    _vm.editStyle = false
                  },
                },
                model: {
                  value: _vm.value.Style,
                  callback: function ($$v) {
                    _vm.$set(_vm.value, "Style", $$v)
                  },
                  expression: "value.Style",
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }